// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var PersonMinus = React.forwardRef(function PersonMinus(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "PersonMinus" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M14.5 13C11.5 13 8 14.0029 8 16V18H21V16C21 14.0029 17.5 13 14.5 13Z", fill: "currentColor" }),
            React.createElement("path", { d: "M17.25 8.75C17.25 10.2688 16.0188 11.5 14.5 11.5C12.9812 11.5 11.75 10.2688 11.75 8.75C11.75 7.23122 12.9812 6 14.5 6C16.0188 6 17.25 7.23122 17.25 8.75Z", fill: "currentColor" }),
            React.createElement("path", { d: "M9 11V9H3V11H9Z", fill: "currentColor" }))));
});
PersonMinus.displayName = 'PersonMinus';
export default PersonMinus;
//# sourceMappingURL=PersonMinus.js.map